import { Nav, Footer, FAQ, C } from "./BuildWell";

export default function FAQPage() {
  return (
    <div style={{ fontFamily: "sans-serif", backgroundColor: C.white }}>
      <Nav />
      <FAQ />
      <Footer />
    </div>
  );
}
